// ts-rest contract for the public status page.
//
// `GET /api/status` is UNAUTHENTICATED (`@Public()` on the controller). It
// replaces the internal System Status page as the surface a client, a partner
// or a monitor reads. It collapses the admin health board into a handful of
// component groups and drops every detail: no version, no host name, no error
// text, no count of client data.

import { initContract } from '@ts-rest/core';
import { publicStatusResponseSchema } from '../schemas/status';

const c = initContract();

export const statusContract = c.router(
    {
        getStatus: {
            method: 'GET',
            path: '/status',
            responses: {
                200: publicStatusResponseSchema,
            },
            summary:
                'Public service health: one overall state word plus one state word for each component group. No authentication.',
        },
    },
    {
        pathPrefix: '/api',
        strictStatusCodes: false,
    },
);
